module.exports = __webpack_public_path__ + "img/cpv.f9922e01.svg";